import styles from './ProcessResult.module.scss';

export const ProcessResult = ({url}: {url: string}) => {
  return (
    <a href={url} target="_blank" rel="noreferrer" className={styles.resultButton}>
      Result
    </a>
  );
};
